<template>
  <abstract-dialog-instance
    v-for="instance in dialogStoreV2.instances"
    :key="instance.identifier"
    :instance="instance as AbstractDialogInstanceType"
  />

  <div ref="dialogTeleportTarget" />
</template>

<script setup lang="ts">
import {
  shallowRef, onMounted,
} from "vue";
import {
  type AbstractDialogInstanceType,
  useDialogStoreV2,
} from "./useDialogStoreV2";
import AbstractDialogInstance from "./instance.vue";

const dialogStoreV2 = useDialogStoreV2();

const dialogTeleportTarget = shallowRef<HTMLDivElement | null>(null);

onMounted(() => {
  if (dialogTeleportTarget.value !== null) {
    dialogStoreV2.setDefaultTeleportedTo(dialogTeleportTarget.value);
  }
});
</script>
